<div class="header-label">
  <h2>File Movement Logs</h2>
</div>

<div class="filter-row">
  <mat-form-field
    appearance="outline"
    class="search-bar"
    subscriptSizing="dynamic"
  >
    <mat-label>Client</mat-label>
    <input
      matInput
      [(ngModel)]="filter.client"
      placeholder="Type client..."
      autocomplete="off"
    />
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="search-bar"
    subscriptSizing="dynamic"
  >
    <mat-label>Status</mat-label>
    <mat-select [formControl]="statusControl">
      <mat-option value="">All statuses</mat-option>
      <mat-option *ngFor="let status of statuses" [value]="status">{{
        status
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="search-bar"
    subscriptSizing="dynamic"
  >
    <mat-label>From date</mat-label>
    <input
      matInput
      [matDatepicker]="fromDatePicker"
      [(ngModel)]="filter.fromDate"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="fromDatePicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #fromDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    class="search-bar"
    subscriptSizing="dynamic"
  >
    <mat-label>To date</mat-label>
    <input
      matInput
      [matDatepicker]="toDatePicker"
      [(ngModel)]="filter.toDate"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="toDatePicker"
    ></mat-datepicker-toggle>
    <mat-datepicker #toDatePicker></mat-datepicker>
  </mat-form-field>

  <div class="filter-button-wrap">
    <button mat-flat-button color="primary" type="button" (click)="onFilter()">
      Filter
    </button>
    <button mat-stroked-button type="button" (click)="clearFilters()">
      Clear
    </button>
  </div>
</div>

<div *ngIf="errorMessage" class="api-error-banner">{{ errorMessage }}</div>
<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    [matSortActive]="sortBy"
    [matSortDirection]="sortDir"
  >
    <ng-container matColumnDef="s3Bucket"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>S3 Bucket</th>
      <td mat-cell *matCellDef="let row">{{ row.s3Bucket }}</td></ng-container
    >
    <ng-container matColumnDef="inputFilePath"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>
        Input File Path
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="path-cell"
        [matTooltip]="row.inputFilePath"
      >
        {{ row.inputFilePath }}
      </td></ng-container
    >
    <ng-container matColumnDef="client"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
      <td mat-cell *matCellDef="let row">{{ row.client }}</td></ng-container
    >
    <ng-container matColumnDef="sourcePath"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>Source Path</th>
      <td
        mat-cell
        *matCellDef="let row"
        class="path-cell"
        [matTooltip]="row.sourcePath"
      >
        {{ row.sourcePath }}
      </td></ng-container
    >
    <ng-container matColumnDef="destinationPath"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>
        Destination Path
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="path-cell"
        [matTooltip]="row.destinationPath"
      >
        {{ row.destinationPath }}
      </td></ng-container
    >
    <ng-container matColumnDef="status"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td></ng-container
    >
    <ng-container matColumnDef="statusDesc"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>
        Status Description
      </th>
      <td mat-cell *matCellDef="let row">{{ row.statusDesc }}</td></ng-container
    >
    <ng-container matColumnDef="date"
      ><th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.date | date: "medium" }}
      </td></ng-container
    >

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div
    *ngIf="dataSource.data.length === 0 && !loading"
    class="no-results-message"
  >
    No file movement logs found
  </div>
</div>

<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="onPageChange($event)"
  showFirstLastButtons
></mat-paginator>
